const styles = () => ({
  headerImage: {
    height: 240,
    width: '100%',
    objectFit: 'cover',
    minWidth: 0,
  },

  title: {
    fontWeight: 600,
    fontSize: 24,
    marginBottom: 6,
    color: '#27282A',
  },

  timeago: {
    fontSize: 16,
    color: '#596168',
    fontWeight: 'normal',
    marginTop: 6,
    marginBottom: 24,
  },

  body: {
    position: 'relative',
    padding: '40px 40px',
    fontWeight: 400,
    fontSize: 15,
    color: '#27282A',
    lineHeight: '22px',
    flex: 1,
    boxShadow: '0 -1px 0 rgba(42, 48, 55, 0.1)',

    '& strong': {
      fontWeight: 600,
    },

    '& p': {
      marginBottom: 16,
    },

    '& ul': {
      listStyleType: 'disc',
      paddingLeft: 18,
      marginBottom: 16,
    },
  },

  dimTitle: {
    color: '#9badbc',
    fontWeight: 'normal',
    fontSize: 15,
  },
});

export default styles;
